function copy(value, context) {
  if (value == null)
    return value;
  return context.replacementContext.tableIds.get(value) ?? value;
}
export {
  copy
};
//# sourceMappingURL=table.js.map